export default "__VITE_ASSET__DQVgTWsv__"